export default __webpack_public_path__ + "media/fdc414980268da3abc1ff2f7a3c3877d89d82fc41af6e1b1df4d8822fb9e60db.svg";